export default {
  header: {
    blNoTitle: 'Bill of Lading (B/L)',
    copyOrder: 'Copy order',
    viewAllOrders: 'View all orders',
    customer: 'Customer',
    cargoName: 'Cargo',
    weight: 'Weight',
    volume: 'Volume',
    containerQty: 'Containers',
    vehicleUnit: 'vehicles',
    containerUnit: 'containers'
  },
  businessInfo: {
    containerSection: 'Container & cargo',
    noTemplateTitle: 'View template not configured',
    noTemplateSubtitle: 'No published view template for this business type. Contact your administrator.',
    noDataTitle: 'No business information',
    noDataSubtitle: 'No displayable business information for this order',
    columns: {
      type: 'Type',
      containerNo: 'Container no.',
      sealNo: 'Seal no.',
      tareWeight: 'Tare (kg)',
      vgm: 'VGM (kg)',
      packageCount: 'Packages',
      grossWeight: 'Gross (kg)',
      volume: 'Volume (m³)',
      status: 'Status'
    },
    containerStatus: {
      packed: 'Packed',
      inPort: 'In port',
      loaded: 'Loaded',
      discharged: 'Discharged',
      returned: 'Returned'
    }
  },
  timeline: {
    businessTab: 'Business updates',
    logisticsTab: 'Logistics updates',
    time: 'Time',
    description: 'Description',
    noBusiness: 'No business updates yet',
    noLogistics: 'No logistics updates yet',
    contactHint: 'Contact WallTech support to enable logistics tracking'
  }
}
